<template>
  <div class="modal fade create-new-user-modal" id="CreateUserModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar usuário</h1>
                  <button type="button" class="btn-close create-new-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateUser" v-on:submit="createUserMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para criar um usuário</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_user_created" class="form-label fw-medium"
                      >Nome</label
                    >
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_user_created"
                      placeholder="Digite o nome"
                      autocomplete="off"
                      required
                    />
                  </div>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="email_user_created" class="form-label fw-medium"
                      >Email</label
                    >
                    <input
                      type="email"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="email_user_created"
                      placeholder="Digite o email"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="cellphone_user_created" class="form-label fw-medium"
                      >Celular</label
                    >                      
                      <input
                      id="cellphone_user_created"
                      ref="cellphone"
                      type="text"
                      name="cellphone"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="Digite o celular"
                      @keyup="changeInformationInputs('cellphone')"
                      @input="applyMaskPhone"
                      maxlength="15"
                    />
                  </div>

                  <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12">
                    <label class="d-block text-black fw-semibold mb-10">
                      Senha temporária
                    </label>
                    <input
                      ref="password_user_created"
                      type="password"
                      name="password"
                      id="password_user_created"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="**************"
                      @keyup="changeInformationInputs('password_user_created')"
                    />
                  </div>

                  <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12">
                    <label class="d-block text-black fw-semibold mb-10">
                      Confirme a senha temporária
                    </label>
                    <input
                      ref="password_user_created_confirm"
                      type="password"
                      name="confirm_password"
                      id="password_user_created_confirm"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="**************"
                      @keyup="changeInformationInputs('password_user_created_confirm')"
                    />
                  </div>

                  <div class="form-group col-12">
                    <div ref="error_password_message" class="error-password-message">
                      As senhas são diferentes !
                    </div>
                  </div>
                  
                  <div class="form-group col-12">
                    <div ref="error_password_message_caracters" class="error-password-message-caracters">
                      A senha precisa ter pelo menos 1 número e 1 caracter especial !
                    </div>
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiCreateUser" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateUser">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="submit" ref="buttonCreateUser" class="btn btn-success">Criar usuário</button>
                  <button type="button" class="btn btn-danger create-new-user-modal" data-bs-dismiss="modal">Cancelar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>

import api from '../../config/axios.js';

export default {
  name: "CreateUserModal",
  data () {
    return {}
  },
  methods: {
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    checkPassword(password){
      return /[0-9]/.test(password) && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/.test(password);
    },
    createUserMethod(){
      event.preventDefault();

      const name_user_created = document.getElementById("name_user_created").value;
      const email_user_created = document.getElementById("email_user_created").value;
      const password_user_created = document.getElementById("password_user_created").value;
      const password_user_created_confirm = document.getElementById("password_user_created_confirm").value;
      let cellphone_user_created = document.getElementById("cellphone_user_created").value;
      let error = false;

      if(
        name_user_created == "" ||
        email_user_created == "" ||
        cellphone_user_created == "" ||
        password_user_created == "" ||
        password_user_created_confirm == ""
      ){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      cellphone_user_created = cellphone_user_created.replace(/[!@#$(.) /-]/g, "");

      if(name_user_created == ""){
        this.$refs.name_user_created.style.borderColor = "red";
        error = true;
      }

      if(password_user_created == ""){
        this.$refs.password_user_created.style.borderColor = "red";
        error = true;
      }
      
      if(password_user_created_confirm == ""){
        this.$refs.password_user_created_confirm.style.borderColor = "red";
        error = true;
      }

      if(password_user_created != password_user_created_confirm){
        this.$refs.password_user_created.style.borderColor = "red";
        this.$refs.password_user_created_confirm.style.borderColor = "red";
        this.$refs.error_password_message.style.display = "flex";
        error = true;
      } else {
        this.$refs.error_password_message.style.display = "none";
      }

      if(!this.checkPassword(password_user_created)){
        this.$refs.error_password_message_caracters.style.display = "flex";
        error = true;
      } else {
        this.$refs.error_password_message_caracters.style.display = "none";
      }

      if(error){
        return;
      }

      const objUserCreate= {
        "name": name_user_created,
        "email": email_user_created,
        "celular": cellphone_user_created,
        "password": password_user_created,
        "password_confirm": password_user_created_confirm,
        "installation_id": this.$route.params.installation_id
      }

      const buttonCreateUser = this.$refs.buttonCreateUser;
      buttonCreateUser.disabled = true;
      buttonCreateUser.innerHTML = "Criando usuário...";
      const alertResponse = this.alertResponse;

        api.axios.post("/api/create/user", objUserCreate).catch(function(error){
          if(error.response.data != undefined){
            buttonCreateUser.innerHTML = "Criar usuário";
          }
          alertResponse(error.response.data, true);
        }).then(function(response){
          
          if(response != undefined && response.status == 200){
            buttonCreateUser.innerHTML = "Usuário criado com sucesso !";
            window.location.reload();
          } else {
            buttonCreateUser.disabled = false;
            buttonCreateUser.innerHTML = "Criar usuário";
          }
        });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageCreateUser").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateUser").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateUser");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 3000);
      }

      const password = document.getElementById("password_user_delete");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>